import { GenericBtn } from 'pages/finance/v2/FinanceRequest';
import { handleUploadFileUtils } from 'api/fetchers';
import FileUploader from 'component/finance/FIleUploader';
import { Copy } from 'lucide-react';
import React from 'react'
import { Modal } from "react-bootstrap";
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { formatMoney } from 'utilities/formatMoney';
import { useState } from 'react';
import { copyField } from 'utilities/clipboard';



const RepayCryptoModal = ({ show, onClose, trxReceiptDoc,
  setTrxReceiptDoc, amount, wallet, network, onSubmit }) => {
  const [isLoading, setIsLoading] = useState(false)
    const { mutateAsync: uploadDocumentFunc, isLoading: uploadingDocsLoading } = useMutation({
      mutationFn: ({ selectedFile, name }) => handleUploadFileUtils({ selectedFile, name }),
          onError: (error) => {
        console.log({ error });
      },
    });
  
  // handle copy to clipboard
  const handleCopyToClipBoard = async (text) => {
    try {
      await copyField(text);
      toast.success("Copied to clipboard");
    } catch (error) {
      console.log(error);
    }
  }
  
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="border-0 z-[9999]"
      onHide={onClose}
    >
      <Modal.Body
        style={{
          borderRadius: "16px",
          padding: "0px",
          border: "none",
        }}
        className="bg-white rounded-md"
      >
        <>
        <div className="w-full gap-4 px-4 py-4 ">
          <div className="flex items-center justify-between">
            <h5 className="text-xl font-semibold text-gray-90">
              Make a repayment
            </h5>

            <span
              className="cursor-pointer material-icons"
              style={{ color: "#667085" }}
              onClick={onClose}
            >
              close
            </span>
          </div>
          <p className="text-base font-normal text-gray-50">
              Send funds to the provided wallet information
          </p>

          <div className="rounded-md bg-[#FBFCFE] p-6 my-3">
            <div className="flex flex-col justify-center items-center">
              <p className="text-[#6F739B] font-normal text-base">Amount to pay</p>
                <p className="text-2xl font-[450] gap-2"><span>{formatMoney(amount)}</span>  <button onClick={
                  () => handleCopyToClipBoard(amount)
                }><Copy className='!text-primary size-5' color='#6F00FF' /></button> </p>
            </div>


            <div className="bg-[#F7F8FD] gap-3 rounded-md p-6">
                {!wallet || !network ? (
                  <div className="animate-pulse w-full">
                    <div className='flex items-start h-full justify-between overflow-hidden'>
                      <div className='w-4/12 h-5 bg-gray-200 rounded-md'></div>
                      <div className='w-7/12 h-10 bg-gray-200 rounded-md'></div>
                    </div>
                    <div className='flex items-start mt-4 justify-between overflow-hidden'>
                      <div className='w-4/12 h-5 bg-gray-200 rounded-md'></div>
                      <div className='w-7/12 h-5 bg-gray-200 rounded-md'></div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className='flex items-start h-full justify-between overflow-auto'>
                      <p className='w-5/12 font-light text-[#667085]'>Wallet address</p>

                        <div className='flex text-right items-start justify-end gap-2 w-7/12'>
                          <div className="text-base text-left font-[450] break-all">
                            {wallet}
                          </div>
                          <button onClick={
                            () => handleCopyToClipBoard(wallet)
                          }><Copy className='!text-primary size-5' color='#6F00FF' /></button>
                        </div>
                      </div>
                      <div className='flex items-start mt-2 justify-between overflow-auto'>
                        <p className='w-5/12 font-light text-[#667085]'>Network</p>

                        <div className='flex items-start justify-end gap-2 w-7/12'>
                          <p className="text-base capitalize text-right h-full text-wrap font-[450]">
                            {network}
                          </p>
                        </div>
                      </div>
                  </>
                )}
            </div>
          </div>
          <FileUploader
            forFinance={true}
            showSample={true}
            isLoading={uploadingDocsLoading}
            title='Transaction receipt'
            file={trxReceiptDoc}
            noModal
            onChange={async (selectedFile, name) => {
              try {
                const response = await uploadDocumentFunc({
                  selectedFile,
                  name,
                });
                console.log({ response })
                if (response?.statusCode !== 400) {
                  const file = {
                    size: selectedFile?.size,
                    name,
                    url: response?.link,
                  };
                  setTrxReceiptDoc(file);
                } else {
                  toast.error(
                    response?.message || "Error uploading file"
                  );
                }
              } catch (error) {
                console.log({ error }, "error");
              }
            }}
          />
          </div>
          <div
            className="flex items-center justify-end p-3 gap-x-5"
            style={{
              borderTop: "1px solid #E7E9FB",
            }}
          >
             <GenericBtn
              disabled={!trxReceiptDoc || isLoading || !wallet || !network}
              loading={isLoading}
              onClick={async() => {
                setIsLoading(true)
                try {
                  if (!trxReceiptDoc?.url) {
                    toast.error("Please upload transaction receipt");
                    return;
                  }
                  await onSubmit({
                    document: {url: trxReceiptDoc?.url}
                  })
                  setTrxReceiptDoc(null)
                  onClose()
                } catch (error) {
                  console.log(error)
                } finally {
                  setIsLoading(false)
                }
              }}            
              text={isLoading? "Loading..." : "Confirm Payment"}
            />
          </div>
        </>
      </Modal.Body>
    </Modal>
  )
}

export default RepayCryptoModal